export default __webpack_public_path__ + "static/media/logo_walletconnect.66f98648.svg";